module.exports = __webpack_public_path__ + "static/img/1.b331bf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/1.png
// module id = Cfm9
// module chunks = 0